import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { BussinesTripMarkerModel, BussinesTripMarkerStateEnum } from '../Models/BussinesTripMarkerModel';
import { BussinesTripLogic } from '../Logic/BussinesTripLogic';

export interface IBussinesTripMarkerButtonControllerOptions {
    name: string;
    onSelected: (name: string) => void;
}

export class BussinesTripMarkerButtonController extends AnimationBaseController {
    $model: BussinesTripMarkerModel;

    public constructor(
        @Inject private _options: IBussinesTripMarkerButtonControllerOptions,
        @Inject private _gameLogic: BussinesTripLogic
    ) {
        super(_options.name);
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            modelWatch: {
                interactive: (value: boolean) => {
                    this.display.interactive = value;
                },
                state: (value: BussinesTripMarkerStateEnum) => {
                    switch (value) {
                        case BussinesTripMarkerStateEnum.none:
                            this.display.filters = [];
                            break;

                        case BussinesTripMarkerStateEnum.failed:
                        case BussinesTripMarkerStateEnum.selected:
                        case BussinesTripMarkerStateEnum.success:
                            let filter = new PIXI.filters.ColorMatrixFilter();
                            let tint =
                                value === BussinesTripMarkerStateEnum.failed
                                    ? 0xff0000
                                    : 0x00ff00;

                            if (value === BussinesTripMarkerStateEnum.selected) {
                                tint = 0x64AF8B
                            }

                            const r = (tint >> 16) & 0xff;
                            const g = (tint >> 8) & 0xff;
                            const b = tint & 0xff;

                            filter.matrix[0] = r / 255;
                            filter.matrix[6] = g / 255;
                            filter.matrix[12] = b / 255;

                            this.display.filters = [filter];
                            break;
                    }
                },
            },
            onPointerDown: () => {
                if (!this.isSelected()) {
                    this.select();

                    if (this._options.onSelected) {
                        this._options.onSelected(this._options.name);
                    }
                }
            },
            onPointerOver: () => {
                if (!this.isSelected()) {
                    this.gotoAndStop('over');
                }
            },
            onPointerOut: () => {
                if (!this.isSelected()) {
                    this.gotoAndStop('up');
                }
            },
            onPointerUp: () => {
                if (!this.isSelected()) {
                    this.gotoAndStop('up');
                }
            },
        };
    }

    protected onInitialize(): void {}

    private select(): void {
        this.gotoAndStop('down');
        this._gameLogic.onCitySelect(this.$model);
    }

    private deselect(): void {
        this.gotoAndStop('up');
        this._gameLogic.onCityDeselect(this.$model);
    }

    private isSelected(): boolean {
        return this._gameLogic.isCitySelected(this.$model);
    }
}
